(ns yardwerkz.web.mapbox
  "Mapbox Geocoding API client for web.
   Adapted from frontend/src/yardwerkz/mapbox.cljs — uses closure-defines instead of expo-constants."
  (:require
   [clojure.string :as str]
   [lambdaisland.glogi :as log]
   [yardwerkz.web.config :as config]))

;; =============================================================================
;; Configuration
;; =============================================================================

(def ^:private geocoding-base-url
  "https://api.mapbox.com/search/geocode/v6")

(defn- get-access-token []
  config/MAPBOX_TOKEN)

(defn- build-url [base-path params]
  (let [url (str geocoding-base-url base-path)]
    (if (seq params)
      (str url "?"
           (->> params
                (filter (fn [[_ v]] (some? v)))
                (map (fn [[k v]] (str (name k) "=" (js/encodeURIComponent (str v)))))
                (str/join "&")))
      url)))

;; =============================================================================
;; Response Parsing
;; =============================================================================

(defn- parse-feature [^js feature]
  (let [props (.-properties feature)
        context (.-context props)
        coords (.-coordinates (.-geometry feature))]
    {:id (.-mapbox_id props)
     :address (or (.-address props) (.-name props))
     :city (some-> context .-place .-name)
     :state (some-> context .-region .-region_code)
     :postal-code (some-> context .-postcode .-name)
     :country (some-> context .-country .-country_code)
     :lng (aget coords 0)
     :lat (aget coords 1)
     :full-address (.-full_address props)}))

(defn- parse-geocode-response [^js response]
  (if (.-ok response)
    (-> (.json response)
        (.then (fn [^js data]
                 (let [features (.-features data)]
                   {:ok true
                    :results (mapv parse-feature features)}))))
    (js/Promise.resolve
     {:ok false
      :error (str "Geocoding failed: " (.-status response))})))

;; =============================================================================
;; Public API
;; =============================================================================

(defn search-address
  "Forward geocoding: search for addresses matching query text."
  [query & {:keys [proximity country limit]
            :or {limit 5}}]
  (let [token (get-access-token)
        [prox-lng prox-lat] proximity
        params {:q query
                :access_token token
                :country country
                :limit limit
                :types "address"
                :proximity (when (and prox-lng prox-lat)
                             (str prox-lng "," prox-lat))}]
    (log/debug :mapbox/search {:query query})
    (-> (js/fetch (build-url "/forward" params))
        (.then parse-geocode-response)
        (.catch (fn [err]
                  (log/error :mapbox/search-error {:error (.-message err)})
                  {:ok false :error "Network request failed"})))))

(defn reverse-geocode
  "Reverse geocoding: convert coordinates to address."
  [lng lat]
  (let [token (get-access-token)
        params {:longitude lng
                :latitude lat
                :access_token token
                :types "address"
                :limit 1}]
    (log/debug :mapbox/reverse {:lng lng :lat lat})
    (-> (js/fetch (build-url "/reverse" params))
        (.then parse-geocode-response)
        (.catch (fn [err]
                  (log/error :mapbox/reverse-error {:error (.-message err)})
                  {:ok false :error "Network request failed"})))))
